<template>
  <div v-if="mfa" class="mfa-auth">
      <div v-if="mfaStep === 0" class="mfa-loader">
        <v-progress-linear :color="appButtonColor" :indeterminate="true"></v-progress-linear>
      </div>
      <div v-else>
        <h2>Alerus MFA Authentication</h2>
        <v-form @submit.prevent>
          <v-container class="pa-0 mt-4">
            <v-layout row wrap v-if="mfaStep === 1">
              <v-flex xs12 sm6>
                <div class="Input__inputLabel___nQolz">Phone</div>
                <v-select
                  v-model="phoneChoice"
                  :items="phones"
                  solo
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <div class="Input__inputLabel___nQolz">Method</div>
                <v-select v-model="verifyChoice" :items="choices" solo></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="mfaStep === 2">
              <v-flex xs12>
                <div class="Input__inputLabel___nQolz">Code</div>
                <v-text-field
                  solo
                  autofocus
                  v-model="mfaAnswer"
                  placeholder="Please enter code"
                  required
                  @keyup.enter="checkChallenge"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="mfaStep === 3">
              <v-flex xs12>
                <div class="Input__inputLabel___nQolz">Code</div>
                <v-text-field
                  solo
                  autofocus
                  v-model="mfaAnswer"
                  placeholder="Please enter code"
                  required
                  @keyup.enter="checkChallenge"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-btn
              :color="appButtonColor"
              class="form-submit ma-0"
              @click="checkChallenge"
              v-if="mfaStep === 1"
            >Submit</v-btn>
            <v-flex v-else>
              <v-btn
                :color="appButtonColor"
                class="form-submit ml-0 mr-4 my-0"
                @click="checkChallenge"
              >Submit</v-btn>
              <v-btn
                v-if="mfaStep !== 3"
                :color="appButtonColor"
                class="form-submit ma-0"
                @click="checkChallenge('resend')"
              >Resend Code</v-btn>
            </v-flex>
          </v-container>
          <div v-if="mfaError" class="migrationError mt-4">{{ mfaErrorMessage }}</div>
        </v-form>
      </div>
  </div>
      <!-- <div v-if="mfaError">
        <h2>There was an error trying to complete your request. Please contact our Client Service Center for help.</h2>
      </div>
      <div v-else-if="mfaResend">
        <div class="migrationError mt-4">New code sent.</div>
      </div> -->
  <div v-else-if="!awsMfa" v-bind:class="amplifyUI.formSection" class="login-form">
    <div v-bind:class="amplifyUI.sectionHeader">
      {{options.header}}
      <p
        v-if="!mersBranded"
        class="welcome-text mb-1"
      >Welcome! Please enter your Username and Password below.</p>
      <p
        v-if="!mersBranded"
        class="welcome-text"
      >If you are a new user, click Create Account below. You are required to register to access your accounts.</p>
      <p
        v-else
        class="welcome-text font-weight-bold"
      >If you have not signed up for an online account or logged in since April 7, 2020, click Create myMERS account.</p>
    </div>
    <div v-bind:class="amplifyUI.sectionBody">
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('Username')}}</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="options.username"
          :placeholder="$Amplify.I18n.get('Enter your username')"
          autofocus
          v-on:keyup.enter="signIn"
        />
        <div v-bind:class="amplifyUI.hint" v-if="mersBranded">
          {{$Amplify.I18n.get('Forgot username? ')}}
          <a
            v-bind:class="amplifyUI.a"
            href="http://www.mersofmich.com/MERS/About-MERS/Contact-Us"
            target="_blank"
          >Call Service Center</a>
        </div>
      </div>
      <div v-bind:class="amplifyUI.formField">
        <div v-bind:class="amplifyUI.inputLabel">{{$Amplify.I18n.get('Password')}}</div>
        <input
          v-bind:class="amplifyUI.input"
          v-model="password"
          type="password"
          :placeholder="$Amplify.I18n.get('Enter your password')"
          v-on:keyup.enter="signIn"
        />
        <div v-bind:class="amplifyUI.hint" v-if="!mersBranded">
          {{$Amplify.I18n.get('Forget your password? ')}}
          <a
            v-bind:class="amplifyUI.a"
            v-on:click="forgot"
          >{{$Amplify.I18n.get('Reset password')}}</a>
        </div>
        <div v-bind:class="amplifyUI.hint" v-else>
          <a
            v-bind:class="amplifyUI.a"
            v-on:click="forgot"
          >{{$Amplify.I18n.get('Forgot password?')}}</a>
        </div>
      </div>
    </div>
    <div v-bind:class="amplifyUI.sectionFooter">
      <span v-bind:class="amplifyUI.sectionFooterPrimaryContent">
        <!-- <button
          v-bind:class="amplifyUI.button"
          v-on:click="signIn"
        >{{$Amplify.I18n.get(mersBranded ? 'Log In' : 'Sign In')}}</button> -->
        <v-btn
          v-bind:class="amplifyUI.button"
          v-on:click="signIn"
          :loading="buttonLoad"
          dark
          depressed
          :color="appButtonColor"
          large
          class="ma-0 load-button"
        >{{$Amplify.I18n.get(mersBranded ? 'Log In' : 'Sign In')}}</v-btn>
      </span>
      <span
        v-bind:class="amplifyUI.sectionFooterSecondaryContent"
        v-if="options.isSignUpDisplayed && !mersBranded"
      >
        {{$Amplify.I18n.get('No account? ')}}
        <a
          v-bind:class="amplifyUI.a"
          v-on:click="signUp"
        >{{$Amplify.I18n.get('Create account')}}</a>
      </span>
      <span
        v-bind:class="amplifyUI.sectionFooterSecondaryContent"
        v-else-if="options.isSignUpDisplayed"
      >
        <a
          v-bind:class="amplifyUI.a"
          v-on:click="signUp"
        >{{$Amplify.I18n.get('Create myMERS account')}}</a>
        <div class="mers-text">
          Employers: If you need assistance creating your account,
          <br />please contact our Service Center at
          <a href="tel:800-767-6377">800-767-6377</a>.
        </div>
      </span>
    </div>
    <div class="error" v-if="error">{{ error }}</div>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" scrollable width="600px" persistent>
        <v-card>
          <v-card-text class="pa-0">
            <privacy />
          </v-card-text>
          <v-card-actions>
            <v-btn :color="appButtonColor" @click="printMe">Print</v-btn>
            <v-spacer></v-spacer>
            <v-btn :color="appButtonColor" @click="getAnswer(false)">Decline</v-btn>
            <v-btn :color="appButtonColor" @click="getAnswer(true)">Accept</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
  <confirm-sign-in v-else></confirm-sign-in>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import * as AmplifyUI from "@aws-amplify/ui";
import Privacy from "@/components/Privacy.vue";
import { mapState } from "vuex";
import VueHtmlToPaper from "@/plugins/print";
import ConfirmSignIn from "@/components/ConfirmSignIn.vue";

export default {
  name: "SignIn",
  props: ["signInConfig"],
  mixins: [VueHtmlToPaper],
  components: {
    Privacy,
    ConfirmSignIn,
  },
  data() {
    return {
      password: "",
      error: "",
      amplifyUI: AmplifyUI,
      logger: {},
      dialog: false,
      userResponse: true,
      terms: false,
      buttonLoad: false,
      choices: ["sms", "voice"],
      phoneChoice: "",
      verifyChoice: "sms",
      userData: "",
      loading: false,
      mfaAnswer:  "",
      mfaError: false,
      mfaErrorMessage: ""
    };
  },
  computed: {
    ...mapState("user", [
      "retirementBranded",
      "retirementBrandedTitle",
      "mersBranded",
      "mersBrandedTitle",
      "step",
      "awsMfa",
      "mfa"
    ]),
    mfaStep() {
      if (this.userData) {
        if (this.userData.challengeName === "SOFTWARE_TOKEN_MFA") {
          return 3
        }
        else if (this.userData.challengeParam) {
          return this.userData.challengeParam.stage ? Number(this.userData.challengeParam.stage) : 0
        }
        else {
          return 0
        }
      }
      else return 0
    },
    phones() {
      if (this.userData) {
        if (this.userData.challengeParam.defaultMfa) {
          this.verifyChoice = this.userData.challengeParam.defaultMfa
        }
        if (this.userData.challengeParam.phones) {
          let phones = (JSON.parse(this.userData.challengeParam.phones)).map(item => item.number)
          this.phoneChoice = phones[0]
          return phones
        }
        else return []
      }
      else {
        return []
      }
    },
    options() {
      const defaults = {
        header: this.retirementBranded
          ? "Access Retirement Account Access"
          : this.mersBranded
          ? "MERS Account Access"
          : "Access MY ALERUS",
        username: "",
        isSignUpDisplayed: true,
      };
      return Object.assign(defaults, this.signInConfig || {});
    },
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0C2B4A";
    },
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  },
  methods: {
    printMe() {
      if (this.step === 1) {
        this.htmlToPaper("consent");
      } else {
        this.htmlToPaper("print");
      }
    },
    getAnswer(val) {
      if (val) {
        if (this.step === 2) {
          this.$store.commit("user/increaseStep");
          this.userResponse = true;
          this.terms = true;
          this.dialog = false;
          this.signIn();
        } else {
          this.$store.commit("user/increaseStep");
        }
      } else {
        this.userResponse = false;
        this.dialog = false;
      }
    },
    async checkChallenge(type = "default")  {
      this.loading = true
      let answer, meta;
      if (this.mfaStep === 1)  {
        if (this.verifyChoice === "totp") {
          this.setupTOTP(this.userData)
          return
        }
        else {
          answer = "phone_select"
          meta = {
            "selected_phone": this.phoneChoice,
            "phone_type": this.verifyChoice
          }
        }
      }
      else if (this.mfaStep === 2) {
        answer = this.mfaAnswer
      }
      else if (this.mfaStep === 3) {
        try {
          this.userData = await this.$Amplify.Auth.confirmSignIn(this.userData, this.mfaAnswer, "SOFTWARE_TOKEN_MFA")
          this.$store.commit("user/setState", "signedIn");
          this.$router.push("/myaccount")
        } catch (error) {
          this.mfaErrorMessage = "Code incorrect."
          this.mfaError = true
        }
        return
      }

      try {
        let data = await this.$Amplify.Auth.sendCustomChallengeAnswer(this.userData, answer, meta)
        if (!data.challengeParam) {
          this.$store.commit("user/setState", "signedIn");
          this.$router.push("/myaccount")
        }
        else {
          if (data.challengeParam.something === "pt4") {
            this.mfaErrorMessage = "Code incorrect."
            this.mfaError = true
          }
          this.userData = data
        }
      } catch (error) {
        this.mfaError = true
        if (error.message === "DefineAuthChallenge failed with error too many attempts.") {
          this.mfaErrorMessage = "Login attempts exceeded. Your account has been locked. Please contact customer support."
        }
        else this.mfaErrorMessage = error.message
      }
      this.loading = false
    },
    async setupTOTP(user) {
      await this.$Amplify.Auth.setupTOTP(user)
    },
    async challenge(user, verify = false) {
      this.userData = user
      if (verify) return
      if (this.mfaStep === 0) {
        user.getCachedDeviceKeyAndPassword()
        this.userData = await this.$Amplify.Auth.sendCustomChallengeAnswer(this.userData, "device_check", {
          "deviceKey": this.userData.deviceKey
        })
      }
      else {
        console.log("wrong mfa step")
      }
    },
    async signIn(event) {
      if (!this.userResponse) {
        this.dialog = true;
        return;
      }
      this.buttonLoad = true
      const that = this;
      let currentPassword = this.password;
      let newUsername = this.options.username.toLowerCase();
      await this.$Amplify.Auth.signIn({
        username: newUsername,
        password: this.password,
        validationData: {
          newUsername: this.options.username,
          agreedTerms: new Date().toISOString(),
          terms: `${this.terms}`
        },
      })
        .then(async (data) => {
          // console.log(data)
          // this.logger.info("sign in success");
          this.$store.commit("user/setAdminReset", false);
          if (
            data.challengeName === "SMS_MFA" ||
            data.challengeName === "SOFTWARE_TOKEN_MFA"
          ) {
            this.$store.commit("user/setMfa", true)
            this.challenge(data, true)
            // AmplifyEventBus.$emit("localUser", data);
            // this.$store.commit("user/setUser", data);
            // this.$store.commit("user/setAWSMfa", true);
            // return AmplifyEventBus.$emit("authState", "confirmSignIn");
          } else if (data.challengeName === "NEW_PASSWORD_REQUIRED") {
            AmplifyEventBus.$emit("localUser", data);
            this.$store.commit("user/setAdminReset", true);
            await this.$Amplify.Auth.completeNewPassword(data, this.password);
            // await this.$Amplify.Auth.forgotPassword(newUsername);
            // await this.$store.dispatch("user/challengeResponse", data.Session);
            this.$store.commit("user/setResetUser", data.username);
            return AmplifyEventBus.$emit("authState", "requireNewPassword");
          } else if (data.challengeName === "MFA_SETUP") {
            AmplifyEventBus.$emit("localUser", data);
            return AmplifyEventBus.$emit("authState", "setMfa");
          } else if (data.challengeName === "CUSTOM_CHALLENGE") {
            this.$store.commit("user/setMfa", true)
            this.challenge(data)
          }
           else {
            return AmplifyEventBus.$emit("authState", "signedIn");
          }
        })
        .catch((e) => {
          this.setError(e);
          if (
            e.message ===
            "PreAuthentication failed with error please accept new terms."
          ) {
            this.dialog = true;
            this.password = currentPassword;
          } else if (e.message === "Password reset required for the user") {
            this.$store.commit("user/setResetUser", this.options.username);
          }
        });
        this.buttonLoad = false
    },
    forgot: function () {
      AmplifyEventBus.$emit("authState", "forgotPassword");
      this.$router.push("/resetpassword");
    },
    signUp: function () {
      AmplifyEventBus.$emit("authState", "signUp");
      this.$router.push("/signup");
    },
    setError: function (e) {
      this.error = this.$Amplify.I18n.get(e.message || e);
      // this.logger.error(this.error);
    },
  },
};
</script>

<style lang="scss" scoped>
.login-form input {
  border: 1px solid lightgray;
}
.welcome-text {
  font-size: 0.9rem;
  margin-top: 0.5rem;
}
.mers {
  .welcome-text {
    font-size: 0.95rem;
  }
  .mers-text {
    // color: #314452;
    margin-top: 1rem;
    font-size: 0.9rem;
  }
}
.load-button {
  border-radius: 0 !important;
  .v-btn__content {
    font-size: inherit !important;
  }
}
.mfa-auth {
  margin: 0 auto;
  max-width: 800px;
  a {
    color: #0C2B4A;
  }
  h2 {
    font-size: 1.25rem;
    font-weight: initial;
    margin-top: 0.5rem;
  }
  .mfa-loader {
    width: 50%;
    margin: 0 auto;
  }
  button {
    text-transform: capitalize;
    color: #fff;
    background-color: #0C2B4A;
    &:active {
      background-color: #0C2B4A;
    }
    &:focus {
      outline: none;
    }
  }
  .error {
    margin-top: 1.5rem;
    color: #fd0000;
  }
  .mers {
  .v-dialog {
    button {
      border-radius: 4px;
    }
    a {
      color: #33715a;
    }
    button {
      background-color: #33715a !important;
      &:active {
        background-color: #33715a !important;
      }
    }
  }
  }
}

</style>